const normalizeRegionName = (value) => String(value || '')
	.trim()
	.toLowerCase();

const getSortedYears = (summary) => Object.keys(summary || {})
	.filter((year) => /^\d{4}$/.test(year))
	.sort((a, b) => Number(a) - Number(b));

const getLatestYear = (summary, fallbackYear) => {
	const years = getSortedYears(summary);

	return years.length ? years[years.length - 1] : fallbackYear;
};

const getPreviousYear = (summary, currentYear) => {
	const years = getSortedYears(summary);
	const currentIndex = years.indexOf(String(currentYear));

	if (currentIndex <= 0) {
		return '';
	}

	return years[currentIndex - 1];
};

const getRegionCount = (yearData, selectedRegion) => {
	if (!yearData || !Array.isArray(yearData.reportsByRegion)) {
		return 0;
	}

	const selectedRegionNormalized = normalizeRegionName(selectedRegion);

	const foundRegion = yearData.reportsByRegion.find((item) => (
		normalizeRegionName(item.region) === selectedRegionNormalized
	));

	return foundRegion ? Number(foundRegion.count || 0) : 0;
};

const formatNumber = (number) => new Intl.NumberFormat('pl-PL').format(Number(number || 0));

const parseSummary = (card) => {
	try {
		const rawSummary = card.dataset.summary || '{}';
		const summary = JSON.parse(rawSummary);

		return summary && typeof summary === 'object' ? summary : {};
	} catch (error) {
		return {};
	}
};

const setReportsVoivodeshipState = (syncKey, data) => {
	window.stop18ReportsVoivodeshipState = window.stop18ReportsVoivodeshipState || {};
	window.stop18ReportsVoivodeshipState[syncKey] = data;
};

const dispatchReportsVoivodeshipUpdate = (data) => {
	window.dispatchEvent(new CustomEvent('stop18:reports-voivodeship:update', {
		detail: data,
	}));
};

const updateReportsVoivodeshipCard = (card) => {
	const summary = parseSummary(card);
	const fallbackYear = card.dataset.defaultYear || '';
	const syncKey = card.dataset.reportsSyncKey || 'stop18-main';
	const defaultVoivodeship = card.dataset.defaultVoivodeship || '';

	const select = card.querySelector('[data-reports-voivodeship-select]');
	const totalElement = card.querySelector('[data-reports-total]');
	const regionCountElement = card.querySelector('[data-reports-region-count]');

	const currentYear = summary[fallbackYear] ? fallbackYear : getLatestYear(summary, fallbackYear);
	const previousYear = getPreviousYear(summary, currentYear);
	const currentYearData = summary[currentYear] || {};
	const previousYearData = previousYear ? summary[previousYear] || {} : {};

	const selectedVoivodeship = select ? select.value : defaultVoivodeship;
	const currentTotal = Number(currentYearData.totalReports || 0);
	const previousTotal = Number(previousYearData.totalReports || 0);
	const regionCount = getRegionCount(currentYearData, selectedVoivodeship);

	if (totalElement) {
		totalElement.textContent = formatNumber(currentTotal);
	}

	if (regionCountElement) {
		regionCountElement.textContent = formatNumber(regionCount);
	}

	const data = {
		syncKey,
		currentYear,
		previousYear,
		currentTotal,
		previousTotal,
		selectedVoivodeship,
		regionCount,
	};

	setReportsVoivodeshipState(syncKey, data);
	dispatchReportsVoivodeshipUpdate(data);
};

const initReportsVoivodeshipCard = () => {
	const cards = document.querySelectorAll('.js-reports-voivodeship-card');

	cards.forEach((card) => {
		const select = card.querySelector('[data-reports-voivodeship-select]');

		updateReportsVoivodeshipCard(card);

		if (!select || select.dataset.reportsVoivodeshipReady === 'true') {
			return;
		}

		select.dataset.reportsVoivodeshipReady = 'true';

		select.addEventListener('change', () => {
			updateReportsVoivodeshipCard(card);
		});
	});
};

document.addEventListener('DOMContentLoaded', initReportsVoivodeshipCard);

if (window.elementorFrontend) {
	window.elementorFrontend.hooks.addAction(
		'frontend/element_ready/stop18_reports_voivodeship_card.default',
		initReportsVoivodeshipCard
	);
}